/**
 * 종목 카테고리별 종목 코드 정의
 * API 응답을 기다리지 않고 카테고리 표시를 위해 사용
 */
/**
 * 종목 그룹 코드
 */
export var StockGroupCode;
(function (StockGroupCode) {
    StockGroupCode["FOREX"] = "01";
    StockGroupCode["INDEX"] = "02";
    StockGroupCode["COMMODITY"] = "03";
    StockGroupCode["CRYPTO"] = "04";
})(StockGroupCode || (StockGroupCode = {}));
/**
 * 카테고리별 종목 코드 맵
 * 실제 API 응답 기준
 * 2025-10-22 업데이트
 */
export const SYMBOL_CATEGORIES = {
    // 외환 (Forex) - stockGroupCd: "01"
    forex: [
        'GBPUSD',
        'EURCAD',
        'NZDCHF',
        'AUDUSD',
        'GBPNZD',
        'GBPCHF',
        'USDCHF',
        'USDZAR',
        'NZDUSD',
        'USDSGD',
        'EURJPY',
        'EURCHF',
        'GBPCAD',
        'GBPJPY',
        'EURGBP',
        'USDHKD',
        'CHFJPY',
        'AUDCHF',
        'AUDNZD',
        'NZDJPY',
        'EURNZD',
        'CADCHF',
        'EURAUD',
        'AUDJPY',
        'USDJPY',
        'USDCAD',
        'GBPAUD',
        'EURSGD',
        'NZDCAD',
        'AUDCAD',
        'EURUSD',
        'CADJPY',
    ],
    // 지수 (Index) - stockGroupCd: "02"
    index: ['US30', 'AUS200', 'CN50', 'UK100'],
    // 상품 (Commodity) - stockGroupCd: "03"
    commodity: ['XLMUSD', 'XRPUSD', 'XAGUSD', 'XAUUSD'],
    // 가상화폐 (Crypto) - stockGroupCd: "04"
    crypto: ['LTCUSD', 'ETHUSD', 'BTCUSD'],
};
/**
 * 모든 종목 코드 배열
 * API 응답 기반으로 업데이트
 * 실제 서비스에서 제공되는 종목만 포함
 * 총 43개 종목 (Forex: 32개, Index: 4개, Commodity: 4개, Crypto: 3개)
 */
export const ALL_SYMBOL_CODES = [
    ...SYMBOL_CATEGORIES.forex,
    ...SYMBOL_CATEGORIES.index,
    ...SYMBOL_CATEGORIES.commodity,
    ...SYMBOL_CATEGORIES.crypto,
];
/**
 * 종목 코드가 어느 카테고리에 속하는지 확인
 */
export function getSymbolCategory(stockCd) {
    if (SYMBOL_CATEGORIES.forex.includes(stockCd))
        return 'forex';
    if (SYMBOL_CATEGORIES.index.includes(stockCd))
        return 'index';
    if (SYMBOL_CATEGORIES.commodity.includes(stockCd))
        return 'commodity';
    if (SYMBOL_CATEGORIES.crypto.includes(stockCd))
        return 'crypto';
    return undefined;
}
/**
 * 종목 그룹 코드를 카테고리로 변환
 * API 메타데이터 stockGroupCd: 'FOREIGN'|'INDEX'|'COMMODITY'|'CRYPTO'
 */
export function groupCodeToCategory(stockGroupCd) {
    if (!stockGroupCd)
        return undefined;
    switch (String(stockGroupCd).toUpperCase()) {
        case 'FOREIGN':
            return 'forex';
        case 'INDEX':
            return 'index';
        case 'COMMODITY':
            return 'commodity';
        case 'CRYPTO':
            return 'crypto';
        default:
            return undefined;
    }
}
//# sourceMappingURL=symbol-categories.js.map